import { render, staticRenderFns } from "./SfRadio.vue?vue&type=template&id=fbea212c&"
import script from "./SfRadio.vue?vue&type=script&lang=js&"
export * from "./SfRadio.vue?vue&type=script&lang=js&"
import style0 from "./SfRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports